<template>
    <v-select
    v-model="selected"
    :items="options"
    item-text="Name"
    item-value="value"
    outlined
    hide-details="true"
    label="Day"
    id="dayOfWeek_ddl"
    @input="val => $emit('input', val)"
    ref="select"
  >
  </v-select>
</template>

<script>
import StyledSelect from '@/components/common/dropDownList/StyledSelectVModel'
import { EXPORT_DAY_OF_WEEK } from '@/appLogic/targets/Constants'

export default {
  components: {
    StyledSelect
  },
  props: {
    value: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: this.value || 0
    }
  },
  computed: {
    options () {
      return EXPORT_DAY_OF_WEEK
    },
  },
  methods: {
    clear () {
      this.$refs.select.clear()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// DayOfWeekDDL.vue?3b0ce3f5